/** Temporarily replace server-rendered SEO tags while a route owns the head. */
export const detachPageSeo = () => {
  const elements = Array.from(document.head.querySelectorAll(
    'meta[name="description"], meta[name="keywords"], meta[property^="og:"], ' +
    'meta[property^="article:"], meta[name^="twitter:"], link[rel="canonical"], ' +
    'link[rel="alternate"][hreflang], [data-static-seo]'
  ));
  elements.forEach(element => element.remove());
  return () => elements.forEach(element => {
    // Canonicals and server-rendered schemas belong only to the original route.
    if (!element.matches('link[rel="canonical"], [data-static-seo]')) {
      document.head.appendChild(element);
    }
  });
};
